import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  beta: {
    id: 'frontbucket.pipelines.components.aiAssistant.beta',
    description: 'The message shown in Lozenge in footer of AI assistants',
    defaultMessage: 'Beta',
  },
  disclaimer: {
    id: 'frontbucket.pipelines.components.aiAssistant.disclaimer',
    description: 'The disclaimer message in the footer of AI assistants',
    defaultMessage: 'Uses AI. Verify results.',
  },
  aiWorking: {
    id: 'frontbucket.pipelines.components.aiAssistant.aiWorking',
    description: 'The message in AI assistants when loading results',
    defaultMessage: 'Generating',
  },
  helpful: {
    id: 'frontbucket.pipelines.components.aiAssistant.helpful',
    description: 'The label in AI assistants positive feedback button',
    defaultMessage: 'Helpful',
  },
  notHelpful: {
    id: 'frontbucket.pipelines.components.aiAssistant.notHelpful',
    description: 'The label in AI assistants negative feedback button',
    defaultMessage: 'Not helpful',
  },
  copy: {
    id: 'frontbucket.pipelines.components.aiAssistant.copy',
    description: 'The label in AI assistants copy button',
    defaultMessage: 'Copy to clipboard',
  },
  copied: {
    id: 'frontbucket.pipelines.components.aiAssistant.coped',
    description: 'The label in AI assistants copy button after copying',
    defaultMessage: 'Copied to clipboard',
  },
  close: {
    id: 'frontbucket.pipelines.components.aiAssistant.close',
    description: 'The label in AI assistant close buttons',
    defaultMessage: 'Close',
  },
  tryAgain: {
    id: 'frontbucket.pipelines.components.aiAssistant.tryAgain',
    description: 'The label in AI assistant Try again button',
    defaultMessage: 'Try again',
  },
});
